import React, { useEffect, useState } from "react";
import Maincomponent from "../../../Components/Maincomponent/Maincomponent";
import { Tabhelper } from "../../../Helper/Tabhelper";
import { useParams } from "react-router-dom";
import {
    FunnelChart,
    Funnel,
    Tooltip,
    LabelList,
    ResponsiveContainer,
} from "recharts";
import Apiurl from "../../../Apiurl";
import axios from "axios";

export default function Crmdash() {
    const [jsonList, setJsonList] = useState([]);
    const { user } = useParams();
    const colors = ["#6366F1", "#3B82F6", "#F59E0B", "#14B8A6"];
    const data = [
        { name: "Base → Lead", value: 80 },
        { name: "Lead → Prospect", value: 65 },
        { name: "Prospect → Registered", value: 15 },
        { name: "Overall Conversion", value: 10 },
    ];
    const getRandomColor = () =>
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    const coloredData = data.map(item => ({
        ...item,
        fill: getRandomColor()
    }));
    const apiurl = Apiurl();

    // Dummy data - replace with API call later
    useEffect(() => {
        fetchData();
    }, []);
    const [dashboardData, setDashboardData] = useState({
        statusDistribution: [],
        topPerformers: [],
        totalLeads: 0,
        conversionRate: 0,
        dropRate: 0,
        registered: 0
    });
    // const dashboardData = {
    //     totalLeads: 1250,
    //     unassigned: 180,
    //     base: 320,
    //     lead: 285,
    //     prospect: 245,
    //     followup: 150,
    //     notInterested: 45,
    //     registered: 25,
    //     conversionRate: 68.5,
    //     dropRate: 12.3,
    //     topPerformers: [
    //         { name: "Rajesh Kumar", leads: 145, conversions: 98 },
    //         { name: "Priya Sharma", leads: 132, conversions: 89 },
    //         { name: "Amit Patel", leads: 128, conversions: 85 }
    //     ],
    //     recentActivities: [
    //         { student: "Aarav Singh", school: "Delhi Public School", status: "Registered", time: "2 hours ago" },
    //         { student: "Diya Verma", school: "Ryan International", status: "Followup", time: "3 hours ago" },

    //     ],
    //     statusDistribution: [
    //         { status: "Unassigned", count: 180, color: "#6366F1", gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
    //         { status: "Base", count: 320, color: "#10B981", gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)" },
    //         { status: "Lead", count: 285, color: "#3B82F6", gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)" },
    //         { status: "Prospect", count: 245, color: "#F59E0B", gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)" },
    //         { status: "Followup", count: 150, color: "#8B5CF6", gradient: "linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)" },
    //         { status: "Not Interested", count: 45, color: "#EF4444", gradient: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)" },
    //         { status: "Registered", count: 25, color: "#14B8A6", gradient: "linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)" }
    //     ]
    // };

    async function fetchData() {

        try {
            const response = await axios.get(apiurl + `dashboard-summary/`);
            setDashboardData(response.data);
        } catch (error) {
            console.error(error);
        } finally {

        }
    }

    useEffect(() => {
        Tabhelper(
            {
                name: "CRM Dashboard",
                link: "/crmdashboard",
                active: "no",
            },
            setJsonList
        );
    }, []);

    const StatCard = ({ title, value, subtitle, gradient, icon }) => (
        <div style={{
            background: gradient,
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            flex: 1,
            minWidth: "220px",
            color: "white",
            position: "relative",
            overflow: "hidden"
        }}>
            <div style={{
                position: "absolute",
                top: "-20px",
                right: "-20px",
                fontSize: "80px",
                opacity: "0.2"
            }}>{icon}</div>
            <div style={{ position: "relative", zIndex: 1 }}>
                <div style={{ fontSize: "14px", opacity: 0.9, marginBottom: "8px", fontWeight: "500" }}>{title}</div>
                <div style={{ fontSize: "36px", fontWeight: "700", marginBottom: "4px" }}>{value}</div>
                {subtitle && <div style={{ fontSize: "12px", opacity: 0.8 }}>{subtitle}</div>}
            </div>
        </div>
    );

    return (
        <Maincomponent tabname={"CRM Dashboard"}>
            <div className="component-sub" style={{
                padding: "20px",
                background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                // minHeight: "calc(100vh - 100px)",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                gap: "5px"
            }}>
                {/* Header */}
                {/* <div style={{ marginBottom: "28px" }}>
                    <h2 style={{
                        margin: 0,
                        fontSize: "32px",
                        fontWeight: "700",
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        marginBottom: "8px"
                    }}>CRM Dashboard</h2>
                    <p style={{ margin: 0, color: "#64748b", fontSize: "15px" }}>Real-time overview of your CRM performance</p>
                </div> */}
                <div>
                    {/* Top Stats Row */}
                    <div style={{ display: "flex", gap: "20px", marginBottom: "10px", }}>
                        <StatCard
                            title="Total Leads"
                            value={dashboardData.totalLeads || 0}
                            // subtitle="All time"/
                            gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                            icon="📊"
                        />
                        <StatCard
                            title="Conversion Rate"
                            value={`${dashboardData.conversionRate || 0}%`}
                            // subtitle="+5.2% from last month"
                            gradient="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
                            icon="📈"
                        />
                        <StatCard
                            title="Drop Rate"
                            value={`${dashboardData.dropRate || 0}%`}
                            // subtitle="This month"
                            gradient="linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
                            icon="📉"
                        />
                        <StatCard
                            title="Registered"
                            value={dashboardData.registered || 0}
                            // subtitle="This month"
                            gradient="linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
                            icon="✅"
                        />
                    </div>

                </div>

                {/* Status Distribution Cards */}
                {/* <h3 style={{
                    fontSize: "10px",
                    fontWeight: "700",
                    marginBottom: "16px",
                    color: "#1e293b"
                }}>Status Distribution</h3> */}
                <div style={{ marginBottom: "15px", display: "flex", justifyContent: 'center' }}>
                    <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                        {dashboardData.statusDistribution?.map((item, index) => (
                            <div key={index} style={{
                                background: item.gradient,
                                color: "white",
                                padding: "10px 14px",
                                borderRadius: "12px",
                                fontWeight: "600",
                                fontSize: "14px",
                                boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                                minWidth: "140px",
                                textAlign: "center",
                                transition: "transform 0.2s",
                                cursor: "pointer"
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-4px)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                            >
                                <div style={{ fontSize: "22px", marginBottom: "8px", fontWeight: "700" }}>{item.count}</div>
                                <div style={{ fontSize: "12px", opacity: 0.95, fontWeight: "500" }}>{item.status}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bottom Section - Two Columns */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px" }}>

                    {/* Top Performers */}
                    <div style={{
                        background: "white",
                        borderRadius: "14px",
                        padding: "18px",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                        height: "360px"
                    }}>
                        <h3 style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            marginBottom: "14px",
                            display: "flex",
                            alignItems: "center",
                            color: "#1e293b"
                        }}>
                            <span style={{ fontSize: "20px", marginRight: "6px" }}>🏆</span>
                            Performers
                        </h3>

                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {dashboardData.topPerformers?.map((performer, index) => (
                                <div key={index} style={{
                                    padding: "12px",
                                    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                                    borderRadius: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "1px solid #e2e8f0"
                                }}>
                                    <div>
                                        <div style={{
                                            fontWeight: "700",
                                            fontSize: "14px",
                                            marginBottom: "4px",
                                            color: "#1e293b",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>
                                            {/* <span style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "50%",
                                                background: index === 0 ? "#FFD700" : index === 1 ? "#C0C0C0" : "#CD7F32",
                                                color: "white",
                                                textAlign: "center",
                                                lineHeight: "20px",
                                                fontSize: "11px",
                                                fontWeight: "700",
                                                marginRight: "6px"
                                            }}>
                                                {index + 1}
                                            </span> */}
                                            {performer.name}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#64748b" }}>
                                            {performer.leads} leads • {performer.conversions} conversions
                                        </div>
                                    </div>

                                    <div style={{
                                        background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
                                        color: "white",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "700"
                                    }}>
                                        {Math.round((performer.conversions / performer.leads) * 100)}%
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Recent Activities */}
                    <div
                        style={{
                            background: "white",
                            borderRadius: "14px",
                            padding: "16px",
                            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                            width: "100%",
                            height: "360px",
                        }}
                    >

                        <h2
                            style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginBottom: "10px",
                                color: "#1f2937",
                            }}
                        >
                            Conversion Funnel
                        </h2>

                        {/* Responsive Funnel Container */}
                        <div style={{ width: "100%", height: "300px" }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <FunnelChart>
                                    <Tooltip formatter={(value) => `${value}%`} />

                                    <Funnel dataKey="value" data={coloredData} isAnimationActive>

                                        <LabelList
                                            dataKey="name"
                                            position="right"
                                            style={{ fill: "#111", fontSize: "14px" }}
                                        />

                                        <LabelList
                                            dataKey="value"
                                            position="inside"
                                            formatter={(value) => `${value}%`}
                                            style={{
                                                fill: "white",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                            }}
                                        />

                                    </Funnel>
                                </FunnelChart>
                            </ResponsiveContainer>
                        </div>

                    </div>
                </div>

            </div>
        </Maincomponent>
    );
}
